import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getProjectNameHeader } from '@/utils/imUtils';

const baseUrl = envConfig.formalServer + '/cotton/admin/project/serviceStatus/';

function baseApi() {

    function insert(data) {
        return Post(baseUrl + 'insertProjectServiceStatus', data);
    }

    function deleteData(data) {
        return Post(baseUrl + 'deleteProjectServiceStatus', data);
    }

    function update(data) {
        return Post(baseUrl + 'updateProjectServiceStatus', data);
    }

    function query(data, projectName) {
        return Post(baseUrl + 'queryProjectServiceStatus', data, getProjectNameHeader(projectName));
    }

    return {
        insert, deleteData, update, query
    };
}

export const projectServiceStatusApi = baseApi();
